import { useMemo } from "react";
import { useAppSelector } from "../../hooks/StoreHooks";

export const useTranslationList = (
    entityType: string,
    entityId: string,
    property: string
): Record<string, string> => {
    const translations = useAppSelector(
        (state) =>
            state.translations.data?.[entityType]?.[entityId]?.[property]
    );
    return useMemo(() => {
        return translations ?? {};
    }, [translations]);
};